<template>
  <v-app>
    <router-view></router-view>
    <v-snackbar
      :color="snackbar.color"
      v-model="snackbar.show"
      class="text-center"
    >
      <h3 class="font-weight-light">{{ snackbar.text }}</h3>
      <v-btn icon @click="snackbar.show = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-app>
</template>

<script>
export default {
  name: "App",
  data: () => ({
    snackbar: {
      show: false,
      text: "",
      color: "error"
    }
    //
  }),
  computed: {
    snackbarTrigger() {
      return this.$store.getters["viewstate/globalSnackbar"].trigger;
    }
  },
  watch: {
    snackbarTrigger: function() {
      let globalSnackbar = this.$store.getters["viewstate/globalSnackbar"];
      this.snackbar = {
        show: true,
        text: globalSnackbar.text,
        color: globalSnackbar.color
      };
    }
  }
};
</script>

<style>
.no-text-transform {
  text-transform: none !important;
}
</style>
